import React from 'react'
import { useBindingInfoAPI } from '../../components/BindingInfoHook/useBindingInfoAPI'
import TikTokMiddleScreen from './TikTokMiddleScreen/TikTokMiddleScreen';
import { checkUserAgent } from '../CommonFunction'
import MobileHome from "./Screens/MobileHome";
import ZpiPriorityMobileHome from "./Screens/ZpiPriorityMobileHome";
import {useAdsInfoAPI} from "../../components/AdsInfoHook/useBindingInfoAPI";

const MobileMiddleScreen = () => {
    const bindingInfo = useBindingInfoAPI();
    const adsInfo = useAdsInfoAPI();
    const renderContent = () => {
        let { app_id } = bindingInfo || ''

        let content = '';
        if (bindingInfo && bindingInfo.app_id) {
            let { REACT_APP_MOBILE_ZALO_ONLY, REACT_APP_APPID_CAN_REDIRECT_TO_ZPI } = window.runtime_configs
            let findAppIdZaloOnly = REACT_APP_MOBILE_ZALO_ONLY && REACT_APP_MOBILE_ZALO_ONLY.find(elm => elm === app_id)
            const listRedirectToZPI= REACT_APP_APPID_CAN_REDIRECT_TO_ZPI ?? [];
            if (findAppIdZaloOnly && !checkUserAgent('aloPayClient')) {
                content = <TikTokMiddleScreen bindingInfo={bindingInfo} adsInfo={adsInfo}/>
            }
            else {
                if (listRedirectToZPI.includes(bindingInfo.app_id)) {
                    content = <ZpiPriorityMobileHome bindingInfo={bindingInfo} />;
                } else {
                    content = <MobileHome bindingInfo={bindingInfo} />;
                }
            }
        }
        
        return content
    }

    let renderComponent = renderContent();
    return (
        renderComponent
    )

}

export default MobileMiddleScreen;
